import React from 'react';
import { MapPin, Maximize2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const TerrainCard = ({ terrain }) => {
  return (
    <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group">
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-gray-200">
        <img
          src={terrain.image}
          alt={terrain.title}
          className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
          loading="lazy"
          onError={(e) => {
            e.target.src = 'https://via.placeholder.com/800x600?text=Image+non+disponible';
            e.target.onerror = null;
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      {/* Content */}
      <div className="p-5">
        <h3 className="text-lg font-bold text-gray-800 mb-3 group-hover:text-[#c4d600] transition-colors duration-300">
          {terrain.title}
        </h3>

        <p className="text-2xl font-bold text-[#c4d600] mb-4 group-hover:scale-105 transition-transform duration-300 inline-block">
          {terrain.price > 0 ? `${terrain.price.toLocaleString('fr-FR')} €` : 'Sur demande'}
        </p>

        <div className="space-y-2 mb-4">
          <div className="flex items-center text-gray-600 text-sm group-hover:text-gray-800 transition-colors">
            <MapPin className="w-4 h-4 mr-2 text-[#c4d600]" />
            <span>{terrain.commune || terrain.location}</span>
          </div>
          {terrain.surface > 0 && (
            <div className="flex items-center text-gray-600 text-sm group-hover:text-gray-800 transition-colors">
              <Maximize2 className="w-4 h-4 mr-2 text-[#c4d600]" />
              <span>{terrain.surface} m²</span>
            </div>
          )}
          {terrain.altitude && (
            <div className="flex items-center text-gray-600 text-sm group-hover:text-gray-800 transition-colors">
              <MapPin className="w-4 h-4 mr-2 text-[#c4d600]" />
              <span>{terrain.altitude} m d'altitude</span>
            </div>
          )}
        </div>

        <Link
          to={`/terrain/${terrain.id}`}
          className="inline-flex items-center text-gray-800 hover:text-[#c4d600] font-semibold text-sm transition-all duration-300 group/link"
        >
          voir l'annonce
          <ArrowRight className="w-4 h-4 ml-2 group-hover/link:translate-x-2 transition-transform duration-300" />
        </Link>
      </div>
    </div>
  );
};

export default TerrainCard;